module.exports = __webpack_public_path__ + "static/media/3.b4dfcd91.png";